<template>
  <!-- <div class="limit-page-wrapper">
    <el-empty
      :image="limitImg"
      :description="user.name ? '当前账号不属于内部账号(酷开域账号或tenant)' : '暂无权限'"
    >
      <el-button
        type="primary"
        @click="loginSSO"
        v-if="!user.name"
      >去登录吧</el-button>
    </el-empty>
  </div> -->
  <div class="notfound">
    <img src="@/assets/images/403.png" />
    <div class="message">{{ user.name ? '当前账号不属于内部账号(酷开域账号或tenant)' : '暂无权限' }}</div>
    <!-- <el-link @click="loginSSO">去登录吧</el-link> -->
    <el-button
      type="primary"
      @click="loginSSO"
      v-if="!user.name"
    >去登录吧</el-button>
  </div>
</template>
<script>
import { ssoLogin } from '@/services/login'
export default {
  data () {
    return {
      limitImg: require('@/assets/images/403.png')
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    loginSSO () {
      ssoLogin(this.$route.fullPath)
    }
  }
}
</script>
<style lang="stylus" scoped>
.notfound
  display flex
  justify-content center
  align-items center
  flex-direction column
  padding 150px 0 40px 0
/deep/.el-link
  display inline-block
  line-height 1
  white-space nowrap
  cursor pointer
  background #FFF
  border 1px solid #DCDFE6
  color #606266
  -webkit-appearance none
  text-align center
  box-sizing border-box
  outline 0
  margin 10px 0 0 0
  transition 0.1s
  font-weight 500
  padding 9px 15px
  font-size 12px
  border-radius 3px
/deep/.el-link.is-underline:hover:after
  position absolute
  left 0
  right 0
  height 0
  bottom 0
  border-bottom none
.message
  color $conventional-text
  font-size 18px
  // font-weight 540
  margin-top -30px
  margin-bottom 20px
  // line-height 60px
.limit-page-wrapper
  padding 160px 0 40px 0
  display flex
  justify-content center
  align-items center
</style>
